// Relics (docs/04 §20, docs/05 §4): bought with Teeth in the Reliquary, always active once slotted.
import { B } from './balance';
import { defineRelic, type RelicDef } from './defs';

const mulTag = (m: { valueXByTag: Partial<Record<string, number>> }, tag: string, x: number) =>
  void (m.valueXByTag[tag] = (m.valueXByTag[tag] ?? 1) * x);

export const RELIC_LIST: RelicDef[] = [
  defineRelic({ id: 'glasseye_r', cost: 3, mods: (m) => void (m.startRare += 1) }),
  defineRelic({ id: 'molar', cost: 3, mods: (m) => void (m.luck += 2) }),
  defineRelic({ id: 'brassknuckles', cost: 4, mods: (m) => void (m.holdPerWindow += 2) }),
  defineRelic({ id: 'oiledgears', cost: 4, mods: (m) => void (m.nudgePerWindow += 2) }),
  defineRelic({ id: 'bonedice', cost: 4, mods: (m) => void (m.diceAdvantage = true) }),
  defineRelic({ id: 'weightedcoin', cost: 4, mods: (m) => void (m.hiloTieWins = true) }),
  defineRelic({ id: 'pocketsun', cost: 5, mods: (m) => void (m.candleNoMelt = true) }),
  defineRelic({ id: 'ratcrown', cost: 5, mods: (m) => mulTag(m, 'vermin', 2) }),
  defineRelic({ id: 'chalice_r', cost: 5, mods: (m) => void (m.feedSpin = true) }),
  defineRelic({ id: 'receiptroll', cost: 5, mods: (m) => void (m.payEarlyX *= 2) }),
  defineRelic({ id: 'ledgernames', cost: 6, mods: (m) => void (m.soulMult *= 2) }),
  defineRelic({ id: 'eternalfruit', cost: 6, mods: (m) => void (m.rotNever = true) }),
  defineRelic({ id: 'wheelspoke', cost: 6, mods: (m) => void (m.wheelStepX *= 2) }),
  defineRelic({ id: 'pinballheart', cost: 6, mods: (m) => void (m.goldenPegX = Math.max(m.goldenPegX, 3)) }),
  defineRelic({ id: 'crackedhalo', cost: 7, mods: (m) => void (m.doomMax = Math.min(m.doomMax, 4)) }),
  defineRelic({ id: 'secondstomach', cost: 8, mods: (m) => void (m.charmSlots += 1) }),
  defineRelic({ id: 'silverfork', cost: 8, mods: (m) => void (m.feastStartMorsels += 2) }),
  defineRelic({ id: 'crowsnest', cost: 8, mods: (m) => void (m.draftChoices += 1) }),
  defineRelic({ id: 'deed', cost: 10, mods: (m) => void (m.startTributeAdd = B.DEED_TRIBUTE_ADD) }),
  defineRelic({ id: 'hourglass_r', cost: 10, mods: (m) => void (m.spinsPerWindow += 2) }),
  defineRelic({ id: 'locket', cost: 12, mods: (m) => void (m.locket = true) }),
  defineRelic({
    id: 'saintknuckle',
    cost: 12,
    requires: (meta) => meta.lifetime.dealsRefused >= B.PATH_RELIC_DEALS,
    mods: (m) => void (m.miracleChance = Math.max(m.miracleChance, B.SAINT_MIRACLE)),
  }),
  defineRelic({
    id: 'jarofteeth',
    cost: 12,
    requires: (meta) => meta.lifetime.dealsAccepted >= B.PATH_RELIC_DEALS,
    mods: (m) => {
      m.devourKeep = Math.max(m.devourKeep, B.JAR_DEVOUR_KEEP);
      m.devourXMult += B.JAR_DEVOUR_XMULT;
    },
  }),
  defineRelic({ id: 'sparerack', cost: 20, mods: (m) => void (m.charmSlots += 1) }),
  defineRelic({ id: 'firstcoin', cost: 30, mods: (m) => void m.xMult.push({ source: 'firstcoin', x: 2 }) }),
];
